// assets
import Logo from "assets/logos/s-logo.svg";
// import Percent from 'assets/svg/100.svg'
import Load from "assets/svg/other/loading2.svg";
// import { Link } from 'react-router-dom';
import axios from "axios";
//css
import "pages/styles/auth/ConfirmNumber.css";
import React, { Component, createRef } from "react";
import Recaptcha from "react-google-recaptcha";
import { get, post } from "util/axiosLib";
import { logger } from "util/logger";


export default class VerifyEmail extends Component {
  recaptchaInstance = createRef();

  state = {
    timer: true,
    num1: "",
    num2: "",
    num3: "",
    num4: "",
    num5: "",
  };

  componentDidMount() {
    const sendCode = async () => {
        const token2 = localStorage.getItem("tokentemp2");
        const token1 = localStorage.getItem("tokentemp");

        if (token2 !== null && token2 !== undefined) {
        await this.setState({ tokenTemp: token2 });
        } else {
        await this.setState({ tokenTemp: token1 });
        }

        const token = this.state.tokenTemp;
        const captch = await this.recaptchaInstance.current?.executeAsync();
        this.recaptchaInstance.current?.reset();

        let axiosConfig = {
            headers: {
                authorization: `${token}`,
                "Content-Type": "application/json",
            },
        };

        axios
        .get(
        `${process.env.REACT_APP_API_ENDPOINT}/auth/verifyEmail?humanKey=${captch}`,
        axiosConfig
        )
        .then((res) => {
        logger("RESPONSE RECEIVED: ", res);
        
        const succmsg = document.getElementById("succ-info");
        succmsg.classList.remove("succ-auth-on");
        })
        .catch((err) => {
        logger("AXIOS ERROR: ", err);
        });
    }

    sendCode();
        
    // Timer function
    const startingMinutes = 3;
    let time = startingMinutes * 60;

    const countdownEl = document.getElementById("countdown");

    setInterval(updateCountdown, 1000);

    function updateCountdown() {
      const minutes = Math.floor(time / 60);
      let seconds = time % 60;

      seconds = seconds < 1 ? "0" + seconds : seconds;

      countdownEl.innerHTML = `${minutes} : ${seconds}`;
      if (time !== 0) {
        time--;
      }
      const codeBtn = document.getElementById("send-code");
      if (time === 0) {
        codeBtn.classList.add("show");
      }
    }
  }

  // Auto tab inputs function

  constructor(props) {
    super(props);
    this.state = {
      num1: 0,
    };

    this.inputNum1Ref = React.createRef();
    this.inputNum2Ref = React.createRef();
    this.inputNum3Ref = React.createRef();
    this.inputNum4Ref = React.createRef();
    this.inputNum5Ref = React.createRef();
    this.inputNum6Ref = React.createRef();
  }

  handleChange0 = async (event) => {
    await this.setState({ num6: event.target.value });
    // logger(this.state.num1)
    // if (this.state.num6.length === 1) {
    //   this.inputNum1Ref.current.focus();
    // }
    if (this.state.num6.length !== 1) {
      this.inputNum5Ref.current.focus();
    }
  };
  handleChange1 = async (event) => {
    await this.setState({ num1: event.target.value });
    // logger(this.state.num1)
    if (this.state.num1.length === 1) {
      this.inputNum2Ref.current.focus();
    }
    // if (this.state.num1.length !== 1) {
    //   this.inputNum6Ref.current.focus();
    // }
  };
  handleChange2 = async (event) => {
    await this.setState({ num2: event.target.value });
    // logger(this.state.num1)
    if (this.state.num2.length === 1) {
      this.inputNum3Ref.current.focus();
    }
    if (this.state.num2.length !== 1) {
      this.inputNum1Ref.current.focus();
    }
  };
  handleChange3 = async (event) => {
    await this.setState({ num3: event.target.value });
    // logger(this.state.num1)
    if (this.state.num3.length === 1) {
      this.inputNum4Ref.current.focus();
    }
    if (this.state.num3.length !== 1) {
      this.inputNum2Ref.current.focus();
    }
  };
  handleChange4 = async (event) => {
    await this.setState({ num4: event.target.value });
    // logger(this.state.num1)
    if (this.state.num4.length === 1) {
      this.inputNum5Ref.current.focus();
    }
    if (this.state.num4.length !== 1) {
      this.inputNum3Ref.current.focus();
    }
  };
  handleChange5 = async (event) => {
    await this.setState({ num5: event.target.value });
    // logger(this.state.num1)
    if (this.state.num5.length === 1) {
      this.inputNum6Ref.current.focus();
    }
    if (this.state.num5.length !== 1) {
      this.inputNum4Ref.current.focus();
    }
  };

  loadUser = async (token) => {
    try {
      const headers = {
        authorization: `${token}`,
        "Content-Type": "application/json",
      };

      const getUserReq = await get(
        `${process.env.REACT_APP_API_ENDPOINT}/auth/currentUser`,
        headers
      );
      const userData = JSON.stringify(getUserReq.data.data);
      localStorage.setItem("btm_user", userData);
      logger(localStorage.getItem("btm_user"));

      return Promise.resolve(true);
    } catch (err) {
      return Promise.reject(err);
    }
  };

  handleSubmit = async (event) => {
    try {
      event.preventDefault();

      const verifyCode =
        this.state.num1 +
        this.state.num2 +
        this.state.num3 +
        this.state.num4 +
        this.state.num5 +
        this.state.num6;

      //logger(verifyCode);

      // load gif
      const loaded = document.getElementById("load");
      loaded.classList.add("load-gif-on");

      const token2 = localStorage.getItem("tokentemp2");
      const token1 = localStorage.getItem("tokentemp");

      if (token2 !== null && token2 !== undefined) {
        await this.setState({ tokenTemp: token2 });
      } else {
        await this.setState({ tokenTemp: token1 });
      }

      const token = this.state.tokenTemp;
      //const fromAuth = localStorage.getItem("fromAuth")

      const newCode = {
        code: verifyCode,
      };

      const headers = {
        authorization: `${token}`,
        "Content-Type": "application/json",
      };

      if (navigator.onLine === true) {
         const captch = await this.recaptchaInstance.current?.executeAsync();

          this.recaptchaInstance.current?.reset();

        const verifyReq = await post(
          `${process.env.REACT_APP_API_ENDPOINT}/auth/verifyEmail?humanKey=${captch}`,
          newCode,
          { ...headers }
        );

        logger(verifyReq)

        const loaded = document.getElementById("load");
        loaded.classList.remove("load-gif-on");

        this.setState({
          otherError: "",
          successMsg: "Email verified successfully.",
        });

        // const token = verifyReq.data.data.token;
        // await this.loadUser(token); // Load user into the localstorage

        // localStorage.setItem("tokenset", token);

        //logger(token);

        const errmsg = document.getElementById("error-info");
        errmsg.classList.remove("err-auth-on");
        const succmsg = document.getElementById("succ-info");
        succmsg.classList.add("succ-auth-on");

        // setTimeout(() => {
        //   window.location = "/2fagenerate";
        // }, 1000);
        // if(fromAuth === "signup"){
        //     setTimeout(() => {
        //         window.location = "/confirmnumber";
        //     }, 1000);
        // }

        setTimeout(() => {
            window.location = "/";
        }, 1000);
        
      } else {
        this.setState({ otherError: "Pls check your network connection" });
      }
    } catch (err) {
      logger("AXIOS ERROR: ", err);

      const loaded = document.getElementById("load");
      loaded.classList.remove("load-gif-on");

      const errmsg = document.getElementById("error-info");
      errmsg.classList.add("err-auth-on");
      const succmsg = document.getElementById("succ-info");
      succmsg.classList.remove("succ-auth-on");

      if (err.isAxiosError) {
        const errData = err.response;

        this.setState({
          otherError: errData.data.error,
          successMsg: " ",
        });
      }

      this.setState({
        otherError: "Pls check that the code is correct or request a new one.",
        successMsg: " ",
      });
    }
  };

  handleResend = async (event) => {
    event.preventDefault();

    const loaded = document.getElementById("load");
    loaded.classList.add("load-gif-on");
    //logger(localStorage.getItem("tokentemp2"))

    const token2 = localStorage.getItem("tokentemp2");
    const token1 = localStorage.getItem("tokentemp");

    if (token2 !== null && token2 !== undefined) {
      await this.setState({ tokenTemp: token2 });
    } else {
      await this.setState({ tokenTemp: token1 });
    }

    const token = this.state.tokenTemp;
    const captch = await this.recaptchaInstance.current?.executeAsync();
    this.recaptchaInstance.current?.reset();

    let axiosConfig = {
      headers: {
        authorization: `${token}`,
        "Content-Type": "application/json",
      },
    };


    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}/auth/verifyEmail?humanKey=${captch}`,
        axiosConfig
      )
      .then((res) => {
        logger("RESPONSE RECEIVED: ", res);
        this.setState({
          successMsg: "Code resent.",
        });
        const succmsg = document.getElementById("succ-info");
        succmsg.classList.remove("succ-auth-on");
        setTimeout(() => {
          window.location.reload();
        }, 1200);
      })
      .catch((err) => {
        logger("AXIOS ERROR: ", err);
      });
  };
  //283881

  render() {
    return (
      <div>
        <section className="confirm-num">
          <div className="confirm-num-container">
            <div className="confirm-num-box">
              <div className="confirm-num-content">
                <div className="confirm-num-top">
                  <div className="cn-logo-box">
                    <img src={Logo} alt="logo" />
                  </div>
                  {/* <div className="zero-icon">
                        <img src={Percent} alt="100%" />
                    </div> */}
                  <h1 className="login-title">Verify your email</h1>
                  <p className="cn-details">
                    {" "}
                    Enter the 6-digit code sent to your email
                  </p>
                </div>
                <div className="confirm-num-body">
                  <form onSubmit={this.handleSubmit}>
                    <div className="cn-number-fields">
                      <div>
                        <input
                          id="num1"
                          type="text"
                          maxLength="1"
                          className="cn-inputs right-m2"
                          ref={this.inputNum1Ref}
                          onChange={this.handleChange1}
                          required
                        />
                      </div>
                      <div>
                        <input
                          id="num2"
                          name="num2"
                          type="text"
                          maxLength="1"
                          className="cn-inputs  right-m2"
                          ref={this.inputNum2Ref}
                          onChange={this.handleChange2}
                          required
                        />
                      </div>
                      <div>
                        <input
                          id="num3"
                          name="num3"
                          type="text"
                          maxLength="1"
                          className="cn-inputs  right-m2"
                          ref={this.inputNum3Ref}
                          onChange={this.handleChange3}
                          required
                        />
                      </div>
                      <div>
                        <input
                          id="num4"
                          type="text"
                          maxLength="1"
                          className="cn-inputs  right-m2"
                          ref={this.inputNum4Ref}
                          onChange={this.handleChange4}
                          required
                        />
                      </div>
                      <div>
                        <input
                          id="num5"
                          type="text"
                          maxLength="1"
                          className="cn-inputs  right-m2"
                          ref={this.inputNum5Ref}
                          onChange={this.handleChange5}
                          required
                        />
                      </div>
                      <div>
                        <input
                          id="num6"
                          type="text"
                          maxLength="1"
                          className="cn-inputs  right-m2"
                          ref={this.inputNum6Ref}
                          onChange={this.handleChange0}
                          required
                        />
                      </div>
                    </div>
                    <div className="flex justify-center mt-4">
                      <Recaptcha
                        ref={this.recaptchaInstance}
                        sitekey={process.env.REACT_APP_RECAPTCHA}
                        size={"invisible"}
                      />
                    </div>

                    <div className="cn-submit-box">
                      <input
                        className="cn-submit"
                        type="submit"
                        value="Submit"
                      />
                    </div>
                    <div className="load-gif" id="load">
                      <img src={Load} alt="loading" />
                    </div>

                    <div
                      id="error-info"
                      className="err-auth animate__animated animate__slideInDown"
                    >
                      <p>
                        <strong>{this.state.otherError}</strong>
                      </p>
                    </div>
                    <div
                      id="succ-info"
                      className="succ-auth animate__animated animate__slideInDown"
                    >
                      <p>
                        <strong>{this.state.successMsg}</strong>
                      </p>
                    </div>
                    <br />

                    <p className="cn-bottom green bold" id="countdown">
                      {" "}
                    </p>
                    <p className="cn-bottom hide" id="send-code">
                      <span onClick={this.handleResend} className="green">
                        {" "}
                        Resend Code{" "}
                    
                      </span>
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
